import Big from 'big.js';

Big.DP = 5;
Big.RM = 0;

export const big = (value = '0') => Big(value);

export const formatTokenAmount = (
  value: string,
  decimals = 24,
  precision = 5
) => {
    return value && Big(value).div(Big(10).pow(decimals)).toFixed(precision)
};

export const parseTokenAmount = (value: string, decimals = 24) =>
  value && Big(value).times(Big(10).pow(decimals)).toFixed();

export const removeTrailingZeros = (amount: string) =>
  amount.replace(/\.?0*$/, '');
